module.exports = __webpack_public_path__ + "img/fundo-home-trade.c1a063b1.png";